import type { VinSearchResultView } from "@slfinrtl/ui-bff-routes"
import { getVinSearchResultViewRoute } from "@slfinrtl/ui-bff-routes"
import { isAxiosError } from "axios"
import { useCallback } from "react"
import { useBffDynamic } from "src/hooks"

export const useVinSearch = () => {
	const searchVin = useBffDynamic(getVinSearchResultViewRoute, "inline")

	return useCallback(
		(vin: string): Promise<VinSearchResultView | null> => {
			return searchVin({
				body: undefined,
				pathParams: { vin },
				queryParams: {},
			}).catch((error: unknown) => {
				if (isAxiosError(error) && error.response?.status === 404) {
					return null
				}
				throw error
			})
		},
		[searchVin],
	)
}
